import { render } from "./UnsolvedQuestions.vue?vue&type=template&id=4c7e0848&scoped=true"
import script from "./UnsolvedQuestions.vue?vue&type=script&lang=js"
export * from "./UnsolvedQuestions.vue?vue&type=script&lang=js"

import "./UnsolvedQuestions.vue?vue&type=style&index=0&id=4c7e0848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7e0848"]])

export default __exports__